import {SessionStorage} from "modules/utils";

export abstract class SecretPageUtils {
	private static key = "__SECRET__";

	static isEnabled() {
		return JSON.parse(
			SessionStorage.GET(SecretPageUtils.key) || process.env.REACT_APP_IS_SECRET || "false"
		) as boolean;
	}

	static disable() {
		SessionStorage.SET(SecretPageUtils.key, "false");
	}
}
